export const PRODUCT_BREAK_POINTS = {
  576: {
    slidesPerView: 2,
    spaceBetween: 30,
  },
  990: {
    slidesPerView: 3,
    spaceBetween: 30,
  },
  1300: {
    slidesPerView: 3,
    spaceBetween: 40,
  },
};

export const NFT_BREAK_POINTS = {
  576: {
    slidesPerView: 2,
    spaceBetween: 30,
  },
  990: {
    slidesPerView: 3,
    spaceBetween: 30,
  },
  1300: {
    slidesPerView: 4,
    spaceBetween: 40,
  },
};

export const PRODUCT_LOADING_ARRAY = [1, 2, 3];
export const NFT_LOADING_ARRAY = [1, 2, 3, 4];
